module.exports = __webpack_public_path__ + "static/img/authkey.47f78cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/app/authkey.jpg
// module id = 5zAK
// module chunks = 0